import { Link } from "wouter";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#0F0F0F] font-sans selection:bg-[#D4AF37] selection:text-black">
      <Header />

      <div className="pt-32 pb-24 px-6 min-h-[60vh] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-8xl font-light text-[#D4AF37] mb-4">404</h1>
          <h2 className="text-2xl text-white font-light mb-4">Page Not Found</h2>
          <p className="text-gray-500 mb-8 max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Link
            href="/"
            data-testid="link-home-404"
            className="inline-block px-8 py-3 bg-[#D4AF37] text-black text-[10px] font-bold uppercase tracking-widest rounded-full hover:brightness-110 transition-all"
          >
            Back to Home
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
}
